import { WithId } from "core/types";
import { Controller, useFormContext } from "react-hook-form";
import { Select, SelectProps } from "./select";

export type ControlledSelectProps<T extends WithId = WithId> = Omit<
  SelectProps<T>,
  "onSelectionChange" | "selectedKeys"
> & {
  name: string;
};

export function ControlledSelect<T extends WithId = WithId>({
  name,
  selectionMode = "single",
  ...props
}: ControlledSelectProps<T>) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { onChange, ref: _, value, ...field },
        fieldState,
      }) => {
        return (
          <Select
            {...props}
            {...field}
            {...fieldState}
            errorMessage={fieldState?.error?.message}
            isInvalid={!!fieldState?.error?.message}
            selectedKeys={value}
            selectionMode={selectionMode}
            onSelectionChange={(value) => {
              onChange(Array.from(value));
            }}
          />
        );
      }}
    />
  );
}
